import { Injectable } from '@angular/core';
import { MapLoaderService } from '@api/map/map-loader.service';
import { catchError, from, map, Observable, of, switchMap } from 'rxjs';
import { blank } from '@core/utils/rxjs/blank';
import { Location } from '@shared/utils/models/location';

@Injectable({
  providedIn: 'root',
})
export class MapActionService {
  constructor(private readonly mapLoader: MapLoaderService) {}

  load(): Observable<void> {
    return this.mapLoader.load().pipe(blank());
  }

  searchByAddress(value: string): Observable<Location> {
    return this.load().pipe(
      switchMap(() =>
        from(
          new google.maps.Geocoder().geocode({
            address: value,
          })
        ).pipe(catchError(() => of()))
      ),
      map(response => response.results),
      map(results => {
        const [first] = results;
        const { geometry } = first;

        return new Location(geometry.location.lng(), geometry.location.lat());
      })
    );
  }
}
